import 'css-chunksrc/client/scenes/optimizedGantt/styles.scss';export default {
  "gantt": "_gantt_djnsi_1",
  "section": "_section_djnsi_27",
  "layer": "_layer_djnsi_32",
  "leftPanel": "_leftPanel_djnsi_40",
  "row": "_row_djnsi_50",
  "openedDetails": "_openedDetails_djnsi_64",
  "wbs": "_wbs_djnsi_68",
  "graph": "_graph_djnsi_74",
  "workLoadsRoot": "_workLoadsRoot_djnsi_84",
  "header": "_header_djnsi_88",
  "label": "_label_djnsi_106",
  "grid": "_grid_djnsi_122",
  "workloads": "_workloads_djnsi_131",
  "cell": "_cell_djnsi_135",
  "track": "_track_djnsi_140",
  "thumb": "_thumb_djnsi_153",
  "thumbIcon": "_thumbIcon_djnsi_167",
  "zoomMenu": "_zoomMenu_djnsi_173",
  "unselectable": "_unselectable_djnsi_188",
  "exportButton": "_exportButton_djnsi_192"
};